import { PayslipUser } from '../../../types/types';

/**
 * Un bulletin n'est servable par notre API que s'il porte une clé de stockage.
 *
 * Les bulletins déposés à l'époque du partenariat GererMesAffaires ont vu leur
 * `bucketKey` effacé lors du transfert vers le coffre GMA. Ils restent présents
 * en base, donc listés par `/v2/payslip/user/{userId}/list`, mais l'endpoint
 * d'attachement répond 404. On s'appuie sur cette absence de clé pour afficher
 * l'état réel plutôt que de laisser le salarié cliquer dans le vide.
 */
export function isPayslipAvailable(payslip: PayslipUser): boolean {
  return !!payslip.bucketKey;
}
